import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { firestore } from "firebaseConfig";
import { isSameCalendarDayAsToday } from "utils/dashboardFilters";

const coll = () => collection(firestore, "generalFollowup");
const toDate = (v) => v?.toDate?.() ?? (v ? new Date(v) : null);

export const fetchGeneralFollowups = async ({ uid, clientId, filterMode = "today" }) => {
  if (!clientId && !uid) return [];

  const snap = await getDocs(
    query(coll(), where(clientId ? "clientId" : "adminId", "==", clientId || uid))
  );
  let items = snap.docs.map((d) => ({
    id: d.id,
    ...d.data(),
    followUpDate: toDate(d.data().followUpDate),
  }));

  if (!clientId && filterMode === "today") {
    items = items.filter((i) => isSameCalendarDayAsToday(i.followUpDate));
  }

  const asc = filterMode === "today";
  return items.sort((a, b) => (asc ? 1 : -1) * (a.followUpDate - b.followUpDate));
};

export const saveGeneralFollowup = async ({ id, followUpDate, notes, ...meta }) => {
  const data = {
    ...meta,
    followUpDate: Timestamp.fromDate(new Date(followUpDate)),
    notes: notes?.trim() ?? "",
  };
  if (id) {
    await updateDoc(doc(coll(), id), { ...data, updatedAt: Timestamp.now() });
  } else {
    await addDoc(coll(), { ...data, createdAt: Timestamp.now() });
  }
};

export const deleteGeneralFollowup = ({ id }) => deleteDoc(doc(coll(), id));
